/** 展立性能模式：办公 / 电竞 / 狂暴（非匠盟传感器模式 LP/HP/狂暴） */
import React from "react";
import { useTranslation } from "react-i18next";
import {
  officeModeImg,
  esportModeImg,
  berserkModeImg,
} from "@eweadn-qiankun/shared-assets";
import { Iconfont, useMessage } from "@eweadn-qiankun/shared-components";
import {
  ZHANLI_PERFORMANCE_MODES,
  type ZhanliPerformanceModeUi,
} from "./zhanliPerformanceMode";
import "../SensorModeCard.scss";

interface ZhanliPerformanceModeCardProps {
  protocolMode: number;
  onModeChange: (mode: ZhanliPerformanceModeUi) => void;
  disabled?: boolean;
}

const MODE_META: Record<
  ZhanliPerformanceModeUi,
  {
    img: string;
    icon: string;
    titleKey: string;
    descKey: string;
    className: string;
  }
> = {
  1: {
    img: officeModeImg,
    icon: "officemode",
    titleKey: "mouse.performance.lpModeTitle",
    descKey: "mouse.performance.lpModeDesc",
    className: "mode-lp",
  },
  2: {
    img: esportModeImg,
    icon: "esportmode",
    titleKey: "mouse.performance.hpModeTitle",
    descKey: "mouse.performance.hpModeDesc",
    className: "mode-hp",
  },
  3: {
    img: berserkModeImg,
    icon: "berserkmode",
    titleKey: "mouse.performance.cordedModeTitle",
    descKey: "mouse.performance.cordedModeDesc",
    className: "mode-corded",
  },
};

const ZhanliPerformanceModeCard: React.FC<ZhanliPerformanceModeCardProps> = ({
  protocolMode,
  onModeChange,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const toast = useMessage();

  const onModeClick = (target: ZhanliPerformanceModeUi) => {
    if (disabled) return;
    const active = ZHANLI_PERFORMANCE_MODES.find((m) => m.value === target);
    if (active?.activeValues.includes(protocolMode)) {
      toast.info(t("mouse.performance.sensorModeAlreadyActive"));
      return;
    }
    onModeChange(target);
  };

  return (
    <div className="sensor-mode-card">
      <div className="card-header">
        <h3 className="card-title">
          {t("mouse.performance.zhanliPerformanceMode")}
        </h3>
        <p className="card-description">
          {t("mouse.performance.zhanliPerformanceModeDesc")}
        </p>
      </div>
      <div className="sensor-mode-content">
        <div className="mode-options">
          {ZHANLI_PERFORMANCE_MODES.map((mode) => {
            const uiMode = mode.value as ZhanliPerformanceModeUi;
            const meta = MODE_META[uiMode];
            const isActive = mode.activeValues.includes(protocolMode);
            return (
              <button
                key={mode.value}
                type="button"
                className={`mode-button ${meta.className} ${isActive ? "active" : ""}`}
                aria-disabled={disabled}
                disabled={disabled}
                onClick={() => onModeClick(uiMode)}
              >
                <img
                  src={meta.img}
                  alt={t(meta.titleKey)}
                  className="mode-bg-img"
                />
                <Iconfont icon="check" className="mode-check-icon" />
                <div className="mode-text-container">
                  <div className="mode-icon-placeholder">
                    <Iconfont icon={meta.icon} className="mode-icon" />
                  </div>
                  <div className="mode-label">{t(meta.titleKey)}</div>
                  <div className="mode-description">{t(meta.descKey)}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ZhanliPerformanceModeCard;
